<script>
import {
  downloadICS,
  getGoogleCalendarUrl,
  getOutlookCalendarUrl,
} from '@shared/utils/calendar';

// Menu unique « Ajouter au calendrier » (classes virtuelles, événements du
// calendrier…) : mêmes choix et mêmes icônes partout.
export default {
  name: 'AddToCalendarDropdown',
  props: {
    // Payload commun : { title, description, location, startDate, endDate, url }
    calendarEvent: {
      type: Object,
      required: true,
    },
    position: {
      type: String,
      default: 'is-bottom-left',
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addToGoogleCalendar() {
      window.open(getGoogleCalendarUrl(this.calendarEvent), '_blank', 'noopener');
    },
    addToOutlookCalendar() {
      window.open(getOutlookCalendarUrl(this.calendarEvent), '_blank', 'noopener');
    },
    downloadIcs() {
      const name = (this.calendarEvent.title || 'evenement').replace(/[^a-zA-Z0-9]/g, '_');
      downloadICS(this.calendarEvent, `${name}.ics`);
    },
  },
};
</script>

<template>
  <b-dropdown :position="position" aria-role="menu" :append-to-body="appendToBody">
    <template #trigger>
      <slot name="trigger" />
    </template>
    <b-dropdown-item aria-role="menuitem" @click="downloadIcs">
      <b-icon icon="download" size="is-small" class="mr-2" />
      Télécharger (.ics)
    </b-dropdown-item>
    <b-dropdown-item aria-role="menuitem" @click="addToGoogleCalendar">
      <img
        class="atccomp_icon mr-2"
        src="https://www.gstatic.com/images/branding/product/1x/calendar_2020q4_48dp.png"
        alt="Google Calendar"
      >
      Google Calendar
    </b-dropdown-item>
    <b-dropdown-item aria-role="menuitem" @click="downloadIcs">
      <svg class="atccomp_icon mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
          fill="#000"
        />
      </svg>
      Apple Calendar
    </b-dropdown-item>
    <b-dropdown-item aria-role="menuitem" @click="addToOutlookCalendar">
      <svg class="atccomp_icon mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22 6.5V17.5C22 18.163 21.7366 18.7989 21.2678 19.2678C20.7989 19.7366 20.163 20 19.5 20H9.5C8.83696 20 8.20107 19.7366 7.73223 19.2678C7.26339 18.7989 7 18.163 7 17.5V6.5C7 5.83696 7.26339 5.20107 7.73223 4.73223C8.20107 4.26339 8.83696 4 9.5 4H19.5C20.163 4 20.7989 4.26339 21.2678 4.73223C21.7366 5.20107 22 5.83696 22 6.5Z"
          fill="#0078D4"
        />
        <path
          d="M7 7.5L14.5 12L22 7.5"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 7.5V18.5C2 19.0523 2.44772 19.5 3 19.5H7V6.5H3C2.44772 6.5 2 6.94772 2 7.5Z"
          fill="#0078D4"
        />
        <ellipse cx="4.5" cy="13" rx="2" ry="2.5" fill="white" />
      </svg>
      Outlook
    </b-dropdown-item>
  </b-dropdown>
</template>

<style lang="scss" scoped>
.atccomp_icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

// Le conteneur parent peut être centré (ex. bloc de leçon « Classe virtuelle
// Talkizy ») : on force l'alignement à gauche des entrées, comme un menu
// déroulant standard.
::v-deep .dropdown-item {
  text-align: left;
}
</style>
